import SectionHeading from "./SectionHeading";

const terms = [
  {
    term: "番剧",
    en: "TV Anime",
    icon: "ri-tv-2-line",
    desc: "按季度或按周在电视台与流媒体连载的电视动画，一季通常 11–26 话，是追更最主流的形式。",
  },
  {
    term: "剧场版",
    en: "Movie",
    icon: "ri-movie-line",
    desc: "面向影院放映的长篇动画电影，时长多在 90 分钟以上，画面与配乐规格通常高于电视动画。",
  },
  {
    term: "OVA / OAD",
    en: "Original Animation",
    icon: "ri-disc-line",
    desc: "不通过电视播出的原创动画或番外内容，多随光盘发售，篇幅灵活，用来补完正片或延展日常。",
  },
  {
    term: "补番",
    en: "Catch Up",
    icon: "ri-history-line",
    desc: "指把已经完结或更新已久的作品成段看完，讲究观看顺序，避免跳过外传导致剧情错位。",
  },
  {
    term: "新番",
    en: "Seasonal",
    icon: "ri-calendar-check-line",
    desc: "当季刚开始播出的作品，通常分一月、四月、七月、十月四个档期集中上线。",
  },
  {
    term: "OP / ED",
    en: "Opening / Ending",
    icon: "ri-music-2-line",
    desc: "片头曲与片尾曲的简称，很多作品的 OP/ED 会随剧情推进更换画面，是重要记忆点。",
  },
];

export default function Glossary() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <SectionHeading
        eyebrow="术语速查"
        icon="ri-book-open-line"
        title="动漫类型术语 · 先把称呼对上再挑番"
        description="刚接触时最容易被「番剧、剧场版、OVA、补番」这些说法绕晕。这一节把常见术语用一句话说明白，看完再去分类浏览会顺畅很多。"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {terms.map((item) => (
          <div
            key={item.term}
            className="rounded-lg bg-background-100 border border-background-200/70 p-5 transition-colors hover:border-primary-300"
          >
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading font-bold text-base text-foreground-950">{item.term}</h3>
                <span className="text-xs text-foreground-500">{item.en}</span>
              </div>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}